import { updataModelListState } from '@/utils/model';
import type { ModelDetailsInfo } from '@/types/model';
import { message } from 'ant-design-vue';
import { getModelListLatest } from '@/components/Model/common';
import { defaultModelId, defaultFluxModelId } from '@/assets/artwork';
import router from '@/router';

// 将模型信息更新为最新的信息（判断模型是否被移除）
export async function updateModelInfo(models: ModelDetailsInfo[]) {
  try {
    const modelList = await getModelListLatest(models);

    // 判断是否有模型已经被删除
    if (modelList.some(item => !item)) {
      // 判断首个模型是否为 HolopixV1模型
      const firstModelIsFlux = models[0]?.ckptType === 'Flux';

      const modelId = firstModelIsFlux ? defaultFluxModelId : defaultModelId;

      // 获取默认模型信息
      const [defaultModelInfo] = await getModelListLatest([{ id: modelId }]);
      updataModelListState(models, [defaultModelInfo] as ModelDetailsInfo[]);

      setTimeout(() => {
        if (
          !(
            (router.currentRoute.value.name === 'fission' && defaultModelInfo?.ckptType !== 'Flux')
            || router.currentRoute.value.name === 'sketch'
          )
        ) {
          message.info({
            content: '该作品的模型已被删除，现自动为您切换成默认模型',
            duration: 1.5,
            class: 'artwork-model-delete-tip',
          });
        }
      }, 1500);
    } else {
      updataModelListState(models, modelList as ModelDetailsInfo[]);
    }
  } catch (error) {
    console.log(error);
  }
}